export enum StockMgmtTable {
    Categories = 'Categories',
    Total = 'Total',
}
